// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".offer-reporter-button{font-size:13.5px;margin-top:5px;-webkit-padding-start:0;padding-inline-start:0;color:#78a6b8;cursor:pointer;border:none;background:none}.offer-reporter-button:hover{color:#fff}@media(max-width:550px){.offer-reporter-button{font-size:10px}}", ""]);
// Exports
module.exports = exports;
